export interface WarehouseActionTypes {
  type: WarehouseActions;
  payload?: any;
}

export enum WarehouseActions {
  CREATE_WAREHOUSE = "CREATE_WAREHOUSE",
  GET_WAREHOUSE_LIST = "GET_WAREHOUSE_LIST",
  SET_WAREHOUSE_LIST = "SET_WAREHOUSE_LIST",
  SET_WAREHOUSE_LIST_PAGE_COUNT = "SET_WAREHOUSE_LIST_PAGE_COUNT",
  GET_WAREHOUSE_DATA_BY_ID = "GET_WAREHOUSE_DATA_BY_ID",
  SET_WAREHOUSE_DATA_BY_ID = "SET_WAREHOUSE_DATA_BY_ID",
  EDIT_WAREHOUSE_DATA_BY_ID = "EDIT_WAREHOUSE_DATA_BY_ID",
  DELETE_WAREHOUSE = "DELETE_WAREHOUSE",
}
